<template>
  <el-dialog :title="dialogType==0?'提现处理':'查看凭证'" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="备注" v-if="dialogType==0">
          <el-input v-model="form.remark" placeholder="备注"></el-input>
        </el-form-item>
        <el-form-item label="提现时间" prop="handle_time" v-if="dialogType==0">
          <el-date-picker
            v-model="form.handle_time"
            type="date"
            size="small"
            placeholder="请选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="is-required whd-form-item" label="提现工单凭证" prop="voucher_img">
          <div class="addicon">
            <div class="el-upload el-upload--text" >
              <template v-if="dialogType==0">
                  <uploadSingleImg  :type="50" :property="form.voucher_img" @updateImg="updateImg" ></uploadSingleImg>
              </template>
              <template v-else>
                  <ul v-if="form.voucher_img" class="perview_img">
                    <li><img :src="form.voucher_img" @click="viewImgDialog(form.voucher_img)"/></li>
                  </ul>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </template>
              
            </div>
            <!-- <div class="el-upload__tip">可选填，图片建议尺寸336*336，支付JPG、PNG格式</div> -->
          </div> 
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer" v-if="dialogType==0">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="savePrograma">确 定</el-button>
    </span>
    <!-- 图片裁剪 -->
    <!-- <corpper :visible.sync="corppervisible"
             v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="15"></corpper> -->
    <!--viewImgDialog.vue-->
    <viewImgDialog :privaImgObj="imgsrcCheck" :visible.sync="dialogImgVisible"></viewImgDialog>
    
  </el-dialog>
  
</template>
<script>
  import api from "@/api.js";
  // import corpper from "@/components/dialog/corpper.vue";
  import uploadSingleImg from "@/components/tkdialog/uploadSingleImg.vue";
  import viewImgDialog from "@/components/dialog/viewImgDialog.vue";
  export default {
    name: "withdrawalList",
    components: {
    uploadSingleImg,
    viewImgDialog
    // corpper
  },
    props: ["visible", "dialogType", "dialogContent"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogImgVisible: false,
        imgsrcCheck: null,
        corppervisible: false,
        dialogVisible: this.visible,
        form: {
          withdrawal_id:'',
          handle_time:'',
          voucher_img:'',
          remark:'',
        },
      };
    },
    created() {
      if (this.dialogType === 1) {
        this.form.handle_time = this.dialogContent.handle_time
        this.form.voucher_img = this.dialogContent.voucher_img
      }
     this.form.withdrawal_id = this.dialogContent.id
    //  console.log(2222222222)
    //  console.log(this.form.withdrawal_id)
    },
    methods: {
       //点击展示大图
    viewImgDialog(val) {
        this.imgsrcCheck = val
        this.dialogImgVisible = true 
      },
      updateImg(option) {
        this.form.voucher_img = option.img;
      },
      imgAddBack(option) {
      this.form.voucher_img = option;
      },
      savePrograma() {
       
        if (this.dialogType === 0 && !this.form.handle_time) {
          this.$message.error('请选提现时间');
          return
        }
       
        // // let url_ = api.partner_handleWithdrawal;
        let data_ = {}
        // // data_.voucher_img = this.form.voucher_img
        // // data_.handle_time = this.form.handle_time
        // data_.withdrawal_id = this.dialogContent.id;
        // // console.log(6666666666666)
        // // console.log(data_.withdrawal_id)
        // if (this.dialogType === 1) {
        //   data_.withdrawal_id = this.dialogContent.id;
        // }
        data_=this.form
        this.axios
            .post(api.partner_handleWithdrawal, data_)
            .then(response => {
              if (response.data.code == 0) {
                let title = '已处理!'
                if (this.dialogType === 1) {
                  title = ''
                }
                this.$message({
                  message: title
                });
                this.dialogVisible = false
                this.form.voucher_img = ''
                this.$emit('initFn');
              } else {
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>


